// src/components/Authentication/ResetPassword/resetpassword.js
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './resetpassword.css';

const ResetPassword = () => {
    const [password, setPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [status, setStatus] = useState('idle');
    const [error, setError] = useState(null);
    const navigate = useNavigate();
    const token = window.location.pathname.split('/reset-password/')[1];
    const API_URL = process.env.REACT_APP_API_URL;

    const handleSubmit = async (e) => {
        e.preventDefault();
        setStatus('loading');

        if (password !== confirmPassword) {
            setError('Passwords do not match');
            setStatus('error');
            return;
        }

        try {
            const response = await fetch(`${API_URL}/reset-password/${token}`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ 
                    password,
                    confirm_password: confirmPassword 
                }),
            });

            const data = await response.json();

            if (!response.ok) {
                throw new Error(data.error || 'Password reset failed');
            }

            setStatus('success');
            // Redirect to login after 2 seconds
            setTimeout(() => {
                navigate('/login');
            }, 2000);

        } catch (err) {
            console.error('Reset error:', err); // Added for debugging

            setError(err.message);

            setStatus('error');
        }
    };

    return (
        <div className="reset-password-container">
            <div className="reset-password-box">
                <h2>Reset Password</h2>
                <form onSubmit={handleSubmit}>
                    <div className="input-group">
                        <input
                            type="password"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            placeholder="New Password"
                            className="reset-password-input"
                            required
                            minLength="6"
                        />
                    </div>
                    <div className="input-group">
                        <input
                            type="password"
                            value={confirmPassword}
                            onChange={(e) => setConfirmPassword(e.target.value)}
                            placeholder="Confirm Password"
                            className="reset-password-input"
                            required
                            minLength="6"
                        />
                    </div>
                    <button 
                        type="submit" 
                        className="reset-password-button"
                        disabled={status === 'loading'}
                    >
                        {status === 'loading' ? 'Resetting...' : 'Reset Password'}
                    </button>
                    {status === 'success' && (
                        <p className="success-message">
                            Password reset successful! Redirecting to login...
                        </p>
                    )}
                    {error && (
                        <p className="error-message">{error}</p>
                    )}
                </form>
            </div>
        </div>
    );
};

export default ResetPassword;